import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullTimelineEvent } from '../../../../../../core/services/order-timeline/order-timeline-event.model';

@Component({
  selector: 'app-order-full-timeline-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-full-timeline-item.component.html',
})
export class OrderFullTimelineItemComponent {
  @Input({ required: true }) event!: FullTimelineEvent;
  @Input() isFirst = false;
  @Input() isLast = false;

  expanded = signal(false);

  toggle(): void {
    this.expanded.update((v) => !v);
  }

  formatDate(date: string): string {
    if (!date) return '--';
    return new Date(date).toLocaleString('pt-BR');
  }

  formatJson(data: unknown): string {
    if (data == null) return 'Sem dados';
    try {
      return JSON.stringify(data, null, 2);
    } catch {
      return String(data);
    }
  }
}
